import { ClipboardList, Target } from "lucide-react";
import { cn } from "@/lib/utils";

const MODES = [
  ["opisno", "Opisno praćenje", ClipboardList],
  ["formativno", "Formativno vrednovanje", Target],
];

export const ModeToggle = ({ value, onChange }) => (
  <div
    className="inline-flex w-full sm:w-auto rounded-xl border border-slate-200 bg-white p-1 shadow-sm"
    role="radiogroup"
    data-testid="mode-toggle"
  >
    {MODES.map(([val, label, Icon]) => (
      <button
        key={val}
        type="button"
        role="radio"
        aria-checked={value === val}
        onClick={() => onChange(val)}
        data-testid={`mode-${val}`}
        className={cn(
          "flex-1 sm:flex-none inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-medium rounded-lg transition-colors",
          value === val ? "bg-blue-600 text-white" : "text-slate-600 hover:bg-slate-50"
        )}
      >
        <Icon className="h-4 w-4" />
        {label}
      </button>
    ))}
  </div>
);

export default ModeToggle;
